import * as moment from 'moment/moment';

const sdQuarterlyDueDate = ({ year, type }) => {
	// by 15th of first month of next quarter

	if (year === null || year === undefined || type === null || type === undefined) {
		return moment().set('years', 1900).endOf('days');
	}

	const types = ['Quarter1', 'Quarter2', 'Quarter3', 'Quarter4'];

	if (false === types?.includes(type)) {
		return moment().set('years', 1900).endOf('days');
	}

	const mapping = { Quarter1: 1, Quarter2: 2, Quarter3: 3, Quarter4: 4 };

	const due = moment().quarter(mapping[type]).year(year).add(1, 'quarter').startOf('quarter').date(15).endOf('day');
	return due;
};

const sdAuditedDueDate = ({ year }) => {
	if (year === null || year === undefined) {
		return moment().set('years', 1900).endOf('days');
	}

	const due = moment().year(year).endOf('year').add(3, 'month').endOf('month').endOf('day');
	return due;
};

const sdUnauditedDueDate = ({ year }) => {
	if (year === null || year === undefined) {
		return moment().set('years', 1900).endOf('days');
	}

	const due = moment().year(year).endOf('year').add(1, 'month').date(15).endOf('day');
	return due;
};

const sdIRDueDate = ({ year }) => {
	if (year === null || year === undefined) {
		return moment().set('years', 1900).endOf('days');
	}

	const due = moment().year(year).endOf('year').add(3, 'month').endOf('month').endOf('day');
	return due;
};

export { sdQuarterlyDueDate, sdAuditedDueDate, sdUnauditedDueDate, sdIRDueDate };
